import { useEffect } from "react";
import L from "leaflet";
import "leaflet-polylinedecorator";
import { useMap } from "react-leaflet";

const PolylineDecorator = ({ positions, threshold = 30}) => {
  const map = useMap();

  useEffect(() => {
    const getDistance = (lat1, lon1, lat2, lon2) => {
      const R = 6371e3;
      const toRad = (deg) => (deg * Math.PI) / 180;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    };

    const splitByDistance = (positions, threshold) => {
      const segments = [];
      let current = [];

      for (let i = 0; i < positions.length; i++) {
        const point = positions[i];

        if (current.length === 0) {
          current.push(point);
        } else {
          const last = current[current.length - 1];
          const dist = getDistance(last[0], last[1], point[0], point[1]);

          if (dist <= threshold) {
            current.push(point);
          } else {
            if (current.length > 1) {
              segments.push([...current]);
            }
            current = [point];
          }
        }
      }

      if (current.length > 1) {
        segments.push(current);
      }

      return segments;
    };

    const segments = splitByDistance(positions, threshold);
    const layers = [];

    segments.forEach((segment) => {
      const polyline = L.polyline(segment).addTo(map);
      layers.push(polyline);

      const decorator = L.polylineDecorator(polyline, {
        patterns: [
          {
            offset: 0,
            repeat: 90,
            symbol: L.Symbol.arrowHead({
              pixelSize: 10,
              polygon: false,
              pathOptions: { stroke: true, color: "blue" },
            }),
          },
        ],
      }).addTo(map);

      layers.push(decorator);
    });

    return () => {
      layers.forEach((layer) => map.removeLayer(layer));
    };
  }, [map, positions, threshold]);

  return null;
};

export default PolylineDecorator;
